import React, { useState } from "react";
import "../style.css";
import _ from "lodash";

const NodeSearch = ({ searchNode }) => {
  const [color, setColor] = useState("black");

  const debounceSearch = _.debounce((e) => {
    searchNode(e.target.value) ? setColor("black") : setColor("darkred");
  }, 750);

  const onKeyEnter = (e) => {
    if (e.key === "Enter") {
      debounceSearch(e);
    }
  };

  return (
    <div className={"nodeSearchDiv"}>
      <input
        type="text"
        placeholder="Search node label"
        style={{
          height: "100%",
          width: "100%",
          borderRadius: "10px",
          border: "2px solid #08204d",
          color: color,
          fontWeight: "bold",
        }}
        onChange={debounceSearch}
        onKeyDown={onKeyEnter}
      />
    </div>
  );
};

export default NodeSearch;
